<div class="head" [class.disabled-state]="isDisabled" (click)="toggle()" (keydown.enter)="toggle()" tabindex="0" role="button">
    <span *ngIf="selectedLength === 0" class="placeholder">{{ placeholderText }}</span>
    <ng-container
        *ngTemplateOutlet="isAllSelectedPlaceholderShown ? defaultPlaceholders : customPlaceholders">
    </ng-container>
    <i class="icon-arrow-expand" [ngClass]="{'opened': isOpened}"></i>
</div>
<div
    *ngIf="isOpened" class="list"
    [class.list--topPosition]="!showListOnTop"
    [class.list--bottomPosition]="showListOnTop">

    <div class="search-wrapper" *ngIf="enableFiltering">
        <div class="search-section">
            <input type="text"
                [(ngModel)]="filterQuery"
                (ngModelChange)="setFilterQuery($event)"
                [placeholder]="filterInputPlaceholder"
                maxlength="50"
                (focus)="$event.stopPropagation()"
                (click)="$event.stopPropagation()">
            <i class="icon-search"></i>
            <button id="clear-filter-search"
                appTrackClickButton
                type="button"
                class="icon-cross_16px clear-control"
                [hidden]="!filterQuery.length"
                (click)="$event.stopPropagation(); setFilterQuery('')">
            </button>
        </div>
    </div>

    <ng-container *ngTemplateOutlet="hasFilteredResults && localOptionsList.length ? optionsList : emptyList"></ng-container>

    <ng-template #optionsList>
        <div class="options-wrapper">
            <div class="option" *ngIf="!filterBy">
                <label for="multi-dropdown-select-all">
                    <input
                        id="multi-dropdown-select-all"
                        type="checkbox"
                        [checked]="isAllChecked"
                        [indeterminate]="isSomeChecked"
                        (change)="toggleAllChecked(); selectOption()"
                    >
                    <span></span>
                    All
                </label>
            </div>
            <div *ngFor="let option of localOptionsList | listFilter: filterBy : false; let i = index" class="option">
                <label for="multi-dropdown-option-{{i}}">
                    <input
                        id="multi-dropdown-option-{{i}}"
                        type="checkbox"
                        (change)="selectOption()"
                        [(ngModel)]="option.checked"
                    >
                    <span [innerHTML]="option.value | htmltransfrom | highlight: pipeFilterQuery"></span>
                </label>
            </div>
        </div>
    </ng-template>

    <ng-template #emptyList>
        <div class="options-empty">{{noOptionsPlaceholder}}</div>
    </ng-template>

</div>

<ng-template #defaultPlaceholders>
    <span *ngIf="selectedLength === optionsList.length">All</span>
    <span *ngIf="selectedLength > 0 && selectedLength < optionsList.length">Selected ({{selectedLength}})</span>
</ng-template>

<ng-template #customPlaceholders>
    <span *ngIf="selectedLength > 0">Selected ({{selectedLength}})</span>
</ng-template>
